import { adapter } from '@seek/tealium-adapter';
import { createContext, type ReactNode } from 'react';

import type { Store } from 'src/store/types';

export const AnalyticsContext = createContext<
  (ReturnType<typeof adapter> & { store: Store }) | undefined
>(undefined);

export const AnalyticsProvider = ({
  value,
  children,
}: {
  value: { store: Store };
  children: ReactNode;
}) => (
  <AnalyticsContext.Provider value={{ ...adapter(), store: value.store }}>
    {children}
  </AnalyticsContext.Provider>
);

export const MockAnalyticsProvider = ({
  value: { link = jest.fn(), view = jest.fn(), store },
  children,
}: {
  value: {
    link?: jest.Mock;
    view?: jest.Mock;
    store: Store;
  };
  children: ReactNode;
}) => (
  <AnalyticsContext.Provider
    value={{
      link,
      view,
      store,
    }}
  >
    {children}
  </AnalyticsContext.Provider>
);
